<app-spinner class="loader" *ngIf="loading"></app-spinner>
<router-outlet></router-outlet>
